const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Mudit Singh Bora</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Associate Events Head, UPES-CSI</li>
    <li>
        Supporting event coordination and management.
    </li>
    <li>
        Ensuring successful execution of CSI activities.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
